import React from 'react';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from './HelperText';

export default class EmailInput extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			icon,
			id,
			name,
			style,
			placeholder,
			value,
			onChange,
			helperText,
			fieldErrors
		} = this.props;

		const fieldStyles =
			this.props.tailwindStyles ||
			'border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-bg text-gray-900 dark:text-dark-text';

		return (
			<div className="EmailInput mt-1 mb-4">
				<span className={icon} style={{ fontSize: 16, top: 10, left: 13 }} />
				<input
					type="email"
					autoCapitalize="off"
					autoComplete="off"
					className={`${fieldStyles} block w-full p-2 h-10 rounded placeholder:text-gray-400 dark:placeholder:text-dark-text-secondary ${icon
						? 'has-icon'
						: ''}`}
					id={id}
					name={name}
					style={style}
					placeholder={placeholder}
					value={value || ''}
					onChange={onChange}
				/>
				<div className="p-1">
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : (
						<HelperText>{helperText}</HelperText>
					)}
				</div>
			</div>
		);
	}
}
